import script from "./tab-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./tab-panel.vue?vue&type=script&setup=true&lang=ts"

import "./tab-panel.vue?vue&type=style&index=0&id=54aef6f7&lang=scss&scoped=true"

import exportComponent from "/root/workspace/sso-webclient_Xaij/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54aef6f7"]])

export default __exports__